module.exports = __webpack_public_path__ + "media/world-4-background.afb94f75.mp3";